import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import * as serviceWorker from './serviceWorker';
import App from './App';

import { rootReducer } from './redux';
import { makeGet } from './api/ajax';
import { configureThumbnailToken } from './components/SignedThumbnail/tokenStore';

configureThumbnailToken(() =>
  makeGet('images/thumbnail-token')
    .toPromise()
    .then(({ response }) => response));

const store = createStore(
  rootReducer,
  {},
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('rootApp'),
);

serviceWorker.unregister();
